import { apiPath, authTenantHeaders } from '@/services/api';
import { fetchJson } from '@/lib/http';

export const clustersApi = {
    list: () => fetchJson(apiPath('/api/v1/trusted-clusters'), { credentials: 'include', headers: authTenantHeaders() }),
    create: (data: unknown) => fetchJson(apiPath('/api/v1/trusted-clusters'), {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json', ...authTenantHeaders() },
        body: JSON.stringify(data),
    }),
    remove: (id: string) => fetchJson(apiPath(`/api/v1/trusted-clusters/${encodeURIComponent(id)}`), {
        method: 'DELETE', credentials: 'include', headers: authTenantHeaders(),
    }),
};

export interface RoleMapping {
    remote_role: string;
    local_role: string;
}

/**
 * The mappings to send: trimmed, complete rows only. `incomplete` counts rows
 * with one side filled and the other blank, which block the create.
 */
export function cleanRoleMappings(rows: RoleMapping[]): { mappings: RoleMapping[]; incomplete: number } {
    const trimmed = rows.map((m) => ({ remote_role: m.remote_role.trim(), local_role: m.local_role.trim() }));
    return {
        mappings: trimmed.filter((m) => m.remote_role && m.local_role),
        incomplete: trimmed.filter((m) => !!m.remote_role !== !!m.local_role).length,
    };
}
